import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiResponse } from '@domain/api';
import { ServiceProductItem } from '@hjc/masterdata-types';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServicesService {
  private http = inject(HttpClient);

  async getServices() {
    return firstValueFrom(this.http.get<ApiResponse<ServiceProductItem[]>>('/api/serviceProducts'));
  }

  async getServiceById(id: string) {
    return firstValueFrom(this.http.get<ApiResponse<ServiceProductItem>>(`/api/serviceProducts/${id}`));
  }
}
